let initialized = false;

const FB_STANDARD = {
  view_item: "ViewContent",
  search: "Search",
  add_to_cart: "AddToCart",
  view_cart: "ViewContent",
  begin_checkout: "InitiateCheckout",
  purchase: "Purchase",
  newsletter_signup: "Lead",
  b2b_application: "Lead",
};

export function initAnalytics(s) {
  if (!s) return;
  if (s.google_verification) {
    let m = document.querySelector('meta[name="google-site-verification"]');
    if (!m) { m = document.createElement("meta"); m.name = "google-site-verification"; document.head.appendChild(m); }
    m.content = s.google_verification;
  }
  if (initialized) return;
  initialized = true;
  if (s.ga4_id || s.google_ads_id) {
    const firstId = s.ga4_id || s.google_ads_id;
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${firstId}`;
    document.head.appendChild(script);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    if (s.ga4_id) window.gtag("config", s.ga4_id);
    if (s.google_ads_id) window.gtag("config", s.google_ads_id);
  }
  if (s.meta_pixel_id) {
    const n = (window.fbq = window.fbq || function () { n.queue.push(arguments); });
    n.queue = n.queue || [];
    n.loaded = true;
    n.version = "2.0";
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(script);
    window.fbq("init", s.meta_pixel_id);
    window.fbq("track", "PageView");
  }
}

export function trackEvent(name, params = {}) {
  try {
    if (window.gtag) window.gtag("event", name, params);
    if (window.fbq) {
      if (FB_STANDARD[name]) window.fbq("track", FB_STANDARD[name], params);
      else window.fbq("trackCustom", name, params);
    }
  } catch { /* analytics opsiyonel */ }
}
